'use client'
import { useState } from 'react'

import DonationButton from '@/components/atoms/Buttons/DonationButton'
import Logo from '@/components/atoms/Logo'

import MenuButton from '@/components/atoms/Buttons/MenuButton'

import Navigation from '@/components/molecules/Navigation'
import useIsMobile from '@/hooks/useIsMobile'
import { NonSocialMenuItemType } from '@/types'
import { Container } from '@dynamo-caffeina-dev/airc-ui-kit'
import { GTM_EVENT_SECTION } from '@/lib/tracking/types/GTM_EVENT_SECTION'

const Header = ({ items }: { items: NonSocialMenuItemType[] }) => {
  const isMobile = useIsMobile({
    breakpoint: 768,
  })

  const [menuState, setMenuState] = useState('closed')

  const onClick = () => {
    setMenuState(menuState === 'closed' ? 'opened' : 'closed')
  }

  return (
    <header
      className='airc-header'
      data-status={menuState}
    >
      <Container
        noPadding
        className={'airc-header__container'}
      >
        <div className='airc-header--wrapper'>
          <Logo />
          <div className='airc-header--navigation'>
            <div className='airc-header--navigation__menu'>
              <Navigation
                menu={{
                  direction: 'row',
                  items,
                }}
              />
            </div>
            <div className='airc-header--navigation__action'>
              <DonationButton
                gtmZone={
                  isMobile
                    ? GTM_EVENT_SECTION.DONA_CTA_FOOTER
                    : GTM_EVENT_SECTION.DONA_CTA_HEADER
                }
              />
            </div>
          </div>

          {items?.length ? (
            <MenuButton
              onClick={onClick}
              status={menuState}
            />
          ) : null}
        </div>
      </Container>
    </header>
  )
}

export default Header
